import { round } from 'lodash';
import { AccordionWidgetData, RiskOverviewMetrics } from '../../../models/RiskProducts';
import {
  AGENCY_COMPOSITE_RATING_TITLE,
  ANALYST_RECOMMENDATION_TITLE,
  CQD,
  CREDIT_QUALITY_SCORE_TITLE,
  CREDIT_RISK_ESTIMATE_TITLE,
  CRL,
  FALLEN_ANGEL_SCORE_TITLE,
  PREVIOUS,
  Y3_PERIOD,
  Y5_PERIOD,
} from './RiskOverviewWidget.constants';

export const formatCreValue = (creValue: number | null): string | null => {
  if (creValue) {
    return `${round(creValue * 100, 2)}%`;
  }
  return null;
};

export const getRiskOverviewData = (metrics: RiskOverviewMetrics): AccordionWidgetData[] => {
  if (!metrics) {
    return [];
  }

  return [
    {
      item: { label: CREDIT_QUALITY_SCORE_TITLE, value: metrics.cqs?.cqs },
      children: [{ label: CQD, value: metrics.cqs?.credit_quality_difference }],
    },
    {
      item: { label: FALLEN_ANGEL_SCORE_TITLE, value: metrics.fallen_angel_score },
      children: [],
    },
    {
      item: { label: AGENCY_COMPOSITE_RATING_TITLE, value: metrics.acr?.acr },
      children: [{ label: PREVIOUS, value: metrics.acr?.acr_previous }],
    },
    {
      item: { label: CREDIT_RISK_ESTIMATE_TITLE, value: formatCreValue(metrics.cre?.cre_1y) },
      children: [
        { label: Y3_PERIOD, value: formatCreValue(metrics.cre?.cre_3y) },
        { label: Y5_PERIOD, value: formatCreValue(metrics.cre?.cre_5y) },
        { label: CRL, value: metrics.cqs?.credit_risk_level },
      ],
    },
    {
      item: { label: ANALYST_RECOMMENDATION_TITLE, value: metrics.cs_analyst_recommendation },
      children: [],
    },
  ];
};
